import { render, staticRenderFns } from "./ViewStaffDialog.vue?vue&type=template&id=2d06f3b2&scoped=true"
import script from "./ViewStaffDialog.vue?vue&type=script&lang=js"
export * from "./ViewStaffDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewStaffDialog.vue?vue&type=style&index=0&id=2d06f3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06f3b2",
  null
  
)

export default component.exports